import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ICountry } from "../interfaces/icountry";
import { CountryService } from "../services/country.service";

@Injectable()
export class CountriesResolver implements Resolve<ICountry[]> {
    constructor(private countryService : CountryService) {

    }

    resolve(route:ActivatedRouteSnapshot): Observable<ICountry[]> {
        return this.countryService.getCountries();
    }
}
